import router from '../router';

export function useRouter() {
  return router;
}
